@use '~/theme/theme' as *;

.tooltip {
  background-color: color(grey-800);
  padding: spacing(1.5);
  color: #fff;

  &.light {
    background-color: white;
    color: color(grey-900);

    @include shadow(sm);
  }

  @include border-radius('sm');

  margin-top: spacing(1);

  &[data-entering] {
    animation: slide 250ms;
  }

  &[data-exiting] {
    animation: slide 250ms reverse ease-in;
  }

  & .arrow svg {
    display: block;
    fill: var(--highlight-background);
  }

  &[data-placement='top'] {
    margin-bottom: 8px;

    --origin: translateY(4px);
  }

  &[data-placement='bottom'] {
    margin-top: 8px;

    --origin: translateY(-4px);

    & .arrow svg {
      transform: rotate(180deg);
    }
  }

  &[data-placement='right'] {
    margin-left: 8px;

    --origin: translateX(-4px);

    & .arrow svg {
      transform: rotate(90deg);
    }
  }

  &[data-placement='left'] {
    margin-right: 8px;

    --origin: translateX(4px);

    & .arrow svg {
      transform: rotate(-90deg);
    }
  }
}

@keyframes slide {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.trigger {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  outline: inherit;
  pointer-events: visible;
  text-align: left;
}
